import { Component, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-message-box',
  templateUrl: './message-box-check.component.html',
  styleUrls: ['./message-box-check.component.css']
})
export class MessageBoxCheckDialog {

  message:string;
  checkingData:boolean;
  title = "Información Dreamjobs";
  constructor(public dialogRef: MdDialogRef<MessageBoxCheckDialog>)
  {

  }

  confirm_offer(){
    this.dialogRef.close(true);
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/message-box-check/message-box-check.component.ts